import { useEffect, useSyncExternalStore } from 'react';
import {
  catalogKey,
  getCatalogEntry,
  prefetchSettlements,
  subscribeCatalog,
} from '../catalog';
import type { ClaimsSortId } from '../types';

const SEARCH_DEBOUNCE_MS = 300;

export function useSettlements(query: string, sortId: ClaimsSortId) {
  const key = catalogKey(query, sortId);
  const entry = useSyncExternalStore(
    subscribeCatalog,
    () => getCatalogEntry(key),
    () => getCatalogEntry(key),
  );

  useEffect(() => {
    const delay = query.trim() ? SEARCH_DEBOUNCE_MS : 0;
    const handle = window.setTimeout(() => {
      void prefetchSettlements(query, sortId);
    }, delay);
    return () => window.clearTimeout(handle);
  }, [query, sortId]);

  return {
    items: entry.items,
    loading: entry.status === 'idle' || entry.status === 'loading',
    error: entry.error,
  };
}
